import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  summary: {
    loading: false,
    error: null,
    data: null,
  },
  alerts: {
    loading: false,
    error: null,
    data: null,
  },
  siteOverview: {
    loading: false,
    error: null,
    data: null,
  },
  locations: {
    loading: false,
    error: null,
    data: null,
  },
  operationsOverview: {
    loading: false,
    error: null,
    data: null,
  },
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    // Dashboard Summary
    dashboardSummaryStart: (state) => {
      state.summary.loading = true;
      state.summary.error = null;
    },
    dashboardSummarySuccess: (state, action) => {
      state.summary.loading = false;
      state.summary.data = action.payload;
      state.summary.error = null;
    },
    dashboardSummaryFailure: (state, action) => {
      state.summary.loading = false;
      state.summary.error = action.payload;
    },

    // Dashboard Alerts
    dashboardAlertsStart: (state) => {
      state.alerts.loading = true;
      state.alerts.error = null;
    },
    dashboardAlertsSuccess: (state, action) => {
      state.alerts.loading = false;
      state.alerts.data = action.payload;
      state.alerts.error = null;
    },
    dashboardAlertsFailure: (state, action) => {
      state.alerts.loading = false;
      state.alerts.error = action.payload;
    },

    // Site Overview
    siteOverviewStart: (state) => {
      state.siteOverview.loading = true;
      state.siteOverview.error = null;
    },
    siteOverviewSuccess: (state, action) => {
      state.siteOverview.loading = false;
      state.siteOverview.data = action.payload;
      state.siteOverview.error = null;
    },
    siteOverviewFailure: (state, action) => {
      state.siteOverview.loading = false;
      state.siteOverview.error = action.payload;
    },

    // Operations Overview
    operationsOverviewStart: (state) => {
      state.operationsOverview.loading = true;
      state.operationsOverview.error = null;
    },
    operationsOverviewSuccess: (state, action) => {
      state.operationsOverview.loading = false;
      state.operationsOverview.data = action.payload;
      state.operationsOverview.error = null;
    },
    operationsOverviewFailure: (state, action) => {
      state.operationsOverview.loading = false;
      state.operationsOverview.error = action.payload;
    },

    // Locations
    locationsStart: (state) => {
      state.locations.loading = true;
      state.locations.error = null;
    },
    locationsSuccess: (state, action) => {
      state.locations.loading = false;
      state.locations.data = action.payload;
      state.locations.error = null;
    },
    locationsFailure: (state, action) => {
      state.locations.loading = false;
      state.locations.error = action.payload;
    },
  },
});

export const {
  dashboardSummaryStart,
  dashboardSummarySuccess,
  dashboardSummaryFailure,
  dashboardAlertsStart,
  dashboardAlertsSuccess,
  dashboardAlertsFailure,
  siteOverviewStart,
  siteOverviewSuccess,
  siteOverviewFailure,
  locationsStart,
  locationsSuccess,
  locationsFailure,
  operationsOverviewStart,
  operationsOverviewSuccess,
  operationsOverviewFailure,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
